import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const databricksWorkspace = defineConnector({
  identifier: "databricksWorkspace",
  name: "Databricks workspace",
  tagLine: "Lakehouse data platform",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: ({ databricksInstance }) =>
    domainToRegex(databricksInstance),
  auth: oauthAuth,
  steps: [
    {
      title: "Enter your Databricks (Workspace Level) instance details",
      items: [
        {
          kind: "markdown",
          content:
            "Enter the details for your Databricks (Workspace Level) instance.",
        },
        {
          kind: "input",
          label: "Databricks Instance",
          placeholder: "dbc-a1b2345c-d6e7.cloud.databricks.com",
          required: true,
          target: { kind: "configuration", field: "databricksInstance" },
          helperText: "The instance to your databricks deployment",
        },
      ],
    },
    {
      title: "Create a Databricks (Workspace Level) app",
      items: [
        {
          kind: "markdown",
          content:
            "Open the [Databricks OAuth machine-to-machine docs](https://docs.databricks.com/en/dev-tools/auth/oauth-m2m.html) and create a service principal OAuth secret for the workspace you want to use. Copy the client ID, client secret, and workspace hostname.",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: (configuration) =>
      `https://${configuration.databricksInstance}/oidc/v1/token`,
    tokenEndpointAuthMethod: () => "client_secret_post",
    clientCredentialsFrom: "db",
    scopes: () => ["all-apis"],
  },
  connectionTest: {
    protocol: "http",
    request: (configuration) =>
      `https://${configuration.databricksInstance}/api/2.0/clusters/list`,
  },
  publicEnvVars: ({ databricksInstance }) => ({
    DATABRICKS_URL: databricksInstance ? `https://${databricksInstance}` : "",
  }),
});
